import React from 'react'

export const Inputs = () => {
  return (
    <div className='example-container'>
      <input className='input' type='text' placeholder='Placeholder Text'/>
      <textarea className='textarea' type='text' placeholder='Placeholder Text'></textarea>
    </div>
  )
}
